var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.variant == 'pulse')?_c('pulse-loader',{attrs:{"loading":true,"color":_vm.color,"size":_vm.size}}):(_vm.variant == 'clip')?_c('clip-loader',{attrs:{"loading":true,"color":_vm.color,"size":_vm.size}}):(_vm.variant == 'fade')?_c('fade-loader',{attrs:{"loading":true,"color":_vm.color,"height":_vm.height,"width":_vm.width}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }